import React from 'react'
import { Box, Switch, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'

import { useUser } from '../../../hooks/useUser'
import { useVoiceAgent } from '../../../hooks/useVoiceAgent'
import { Routes as SettingsRoutes } from '../../../helpers/Routes'
import { useVoiceAgentStyles } from '../useVoiceAgentStyles'

export const ServiceRequestToggle: React.FC = () => {
    const classes = useVoiceAgentStyles()
    const { workspaceUser } = useUser()
    const { setupData, agentConfig, saveAgent } = useVoiceAgent()

    const enabled =
        agentConfig?.enable_service_requests ??
        setupData?.enable_service_requests ??
        false
    const propertyAllows = !!workspaceUser?.active_workspace
        ?.allow_service_request

    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        try {
            await saveAgent.mutateAsync({
                enable_service_requests: event.target.checked,
            })
        } catch {
            // toast handled by hook
        }
    }

    return (
        <Box className={classes.serviceToggle}>
            <Box className={classes.serviceToggleCopy}>
                <Typography className={classes.serviceToggleLabel}>
                    Allow the voice agent to submit maintenance requests
                </Typography>
                <Typography className={classes.serviceToggleHelper}>
                    Current residents can file a service request by phone.
                    Requires{' '}
                    <Link
                        to={SettingsRoutes.serviceRequestSettings}
                        className={classes.serviceToggleLink}
                    >
                        Allow service request
                    </Link>{' '}
                    to be on for this property.
                    {!propertyAllows && (
                        <span className={classes.serviceToggleWarn}>
                            {' '}
                            This property currently has it off, so the agent
                            will not be able to submit requests until it is
                            enabled.
                        </span>
                    )}
                </Typography>
            </Box>
            <Switch
                color="primary"
                checked={enabled}
                disabled={saveAgent.isLoading}
                onChange={handleChange}
                inputProps={{
                    'aria-label':
                        'Allow the voice agent to submit maintenance requests',
                }}
            />
        </Box>
    )
}
